import $constants from '@/services/constants'
import Level from '@/models/Level'

const state = {
    levels   : [],
    levels_id: [],
}

const getters = {
    levels     : state => state.levels,
    levels_id  : state => state.levels_id,
}

const mutations = {
    SET_LEVELS   : (state, data) => (state.levels = data),
    SET_LEVELS_ID: (state, data) => state.levels_id = data.map(el => el.id )
}

const actions = {
    async getLevelsData({ commit }) {
        const response = await Level.list({ per_page: $constants.getConstant('MAX-LEVELS-ALLOWED'), page: 1 })

        if(!response && !response.length ) return

        commit('SET_LEVELS', response)
        commit('SET_LEVELS_ID', response)

        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}